import { TUNING_HISTORY_STATUS } from '@parallel-fluidics/shared/models/tuningHistory';
import {
  collection,
  getFirestore,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';

const MAX_TUNING_HISTORY_ITEMS = 10;

export default function getLatestTuningHistoryQuery(pressId) {
  if (!pressId) {
    return null;
  }

  return query(
    collection(getFirestore(), 'tuningHistory'),
    where('pressId', '==', pressId),
    where('status', '==', TUNING_HISTORY_STATUS.COMPLETE),
    orderBy('startTime', 'desc'),
    limit(MAX_TUNING_HISTORY_ITEMS),
  );
}
